import { Component, TemplateRef, OnInit, HostListener, OnDestroy, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

// ** rxjs
import { of } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';

// ** service
import { LayoutService } from '@app/core/services/layout.service';

@Component({
	selector: 'app-nav-header',
	templateUrl: './nav-header.component.html',
	styleUrls: ['./nav-header.component.scss'],
})
export class NavHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
	isCollapsed = true;
	isOpened = false;
	isBrowser = false;

	public getScreenWidth: any;
	public loading: boolean;
	public loadingTemplate!: TemplateRef<any>;

	// ** 聯絡我們顯示與否
	contactFormShow = false;

	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void {
		this.onWindowResize(event);
	}

	// ** 手機選單展開時，點擊選單以外的地方就關閉
	// ** 用 composedPath() 而非 event.target：點擊漢堡按鈕內的 icon 時，
	// ** Angular 的 *ngIf 會在同一次事件循環內把該 icon 節點換掉，
	// ** 屆時 event.target 已從 DOM 移除，contains() 誤判為「點擊外部」而立刻關閉選單
	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		const path = event.composedPath ? event.composedPath() : [event.target];
		const clickedInside = path.includes(this.elementRef.nativeElement);
		if (!this.isCollapsed && !clickedInside) {
			this.ToggleBGFilter();
		}
	}

	constructor(
		private elementRef: ElementRef,
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		public layoutService: LayoutService
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
	}

	onWindowResize(e) {
		this.getScreenWidth = window.innerWidth;
		if (this.getScreenWidth > 991) {
			this.isCollapsed = true;
			const element1 = this.document.querySelector('.wrapper');
			const element2 = this.document.querySelector('.navbar-collapse');
			const element3 = this.document.querySelector('html');

			if (element1) {
				element1?.classList.remove('filter_blur_2px');
			}

			if (element2) {
				element2?.classList.remove('filter_blur_2px');
			}

			if (element3) {
				element3?.classList.remove('no-scroll-bar');
			}
		}
	}

	ngOnInit(): void {
		// this.initView();
	}

	initView() {
		if (this.isBrowser) this.getScreenWidth = window.innerWidth;
		of(this.layoutService.setPageLoading(true))
			.pipe(
				tap(() => this.resetScroll()),
				tap(() => {
					// ** 這邊是 animation 的觸發 code
					// setTimeout(() => {
					// 	if (this.isBrowser) {
					// 		const navbar = this.document.querySelector('.navbar') as HTMLElement | null;
					// 		const banner = this.document.querySelector('.banner_item_1') as HTMLElement | null;
					// 		const imgBg = document.querySelector('.banner_item_1 .imgBox') as HTMLElement | null;
					// 		const img = this.document.querySelector(
					// 			'.banner_item_1 .imgBox .img_main '
					// 		) as HTMLElement | null;
					// 		const words = this.document.querySelector('.banner_item_1 .wordBox ') as HTMLElement | null;
					// 		// if (banner !== null) {
					// 		img?.classList.add('animate__animated', 'animate__delay-1s');
					// 		words?.classList.add('animate__animated', 'animate__delay-1s');
					// 		navbar?.classList.add('animate__animated', 'animate__delay-500ms');
					// 		if (this.isBrowser) {
					// 			img?.style?.setProperty('--animate-duration', '1s');
					// 			words?.style?.setProperty('--animate-duration', '1s');
					// 			navbar?.style?.setProperty('--animate-duration', '300ms');
					// 		}
					// 		// }
					// 	}
					// }, this.layoutService.timeout);
				}),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe();
	}

	onContact() {
		this.contactFormShow = true;
	}

	changeLanguage(lang) {
		// this.translateService.use(lang);
	}

	ToggleBGFilter() {
		if (this.isCollapsed) {
			this.isCollapsed = !this.isCollapsed;
			this.document.querySelector('.wrapper')?.classList.add('filter_blur_2px');
			this.document.querySelector('html')?.classList.add('no-scroll-bar');
		} else {
			this.document.querySelector('.wrapper')?.classList.remove('filter_blur_2px');
			this.document.querySelector('html')?.classList.remove('no-scroll-bar');

			this.isCollapsed = !this.isCollapsed;
		}
	}

	navbarMouseEnter(event) {
		const el = event.currentTarget;
		const parentElement = el.closest('ul.navbar-nav');
		const allChildren = parentElement.childNodes;
		if (this.getScreenWidth > 991) {
			for (const child of allChildren) {
				if (child?.classList) {
					if (child?.classList.contains('open')) {
						child?.classList.remove('open', 'show');
					}
				}
			}
			if (!el?.classList.contains('open')) {
				el?.classList.add('open', 'show');
			}
		}
	}
	navbarMouseLeave(event) {
		const el = event.currentTarget;
		if (this.getScreenWidth > 991) {
			if (el?.classList.contains('open')) {
				for (const child of el.childNodes[1].childNodes) {
					if (!child?.classList.contains('open')) {
						el?.classList.remove('open', 'show');
					}
				}
			}
		}
	}

	navbarListItemsMouseEnter(event) {
		const el = event.currentTarget;
		if (this.getScreenWidth > 991) {
			if (!el?.classList.contains('open')) {
				el?.classList.add('open', 'show');
				el.childNodes[1]?.classList.add('open', 'show');
			}
		}
	}

	navbarListItemsMouseLeave(event) {
		if (this.getScreenWidth > 991) {
			const el = event.currentTarget;
			if (el?.classList.contains('open')) {
				el?.classList.remove('open', 'show');
				el.childNodes[1]?.classList.remove('open', 'show');
			}
		}
	}

	childListMouseEnter(event) {
		const el = event.currentTarget;
		if (this.getScreenWidth > 991) {
			if (!el?.classList.contains('open')) {
				el.closest('.dropdown.nav-item').add('open', 'show');
				el?.classList.add('open', 'show');
				el.closest('a.dropdown-item')?.classList.add('open', 'show');
			}
		}
	}

	childListMouseLeave(event) {
		if (this.getScreenWidth > 991) {
			const el = event.currentTarget;
			if (el?.classList.contains('open')) {
				el?.classList.remove('open', 'show');
			}
		}
	}

	resetScroll() {
		const html = this.document.querySelector('html');
		if (html) html.classList.remove('no-scroll-bar');
	}

	ngAfterViewInit(): void {}

	ngOnDestroy(): void {
		this.loading = true;
	}
}
